import { fromJS } from 'immutable/dist/immutable';
import {
  normalizeInitialFormValues, fieldToNumber, fieldTrimmed,
} from '../../../form/formUtilities';

export const createInitialForm = reference => fromJS({
  id: normalizeInitialFormValues(reference, ['id']),
  author: normalizeInitialFormValues(reference, ['author']),
  year: normalizeInitialFormValues(reference, ['year']),
  citation: normalizeInitialFormValues(reference, ['citation']),
  ok: normalizeInitialFormValues(reference, ['ok']),
  have: normalizeInitialFormValues(reference, ['have'], '-100'),
  comments: normalizeInitialFormValues(reference, ['comments']),
  publish: normalizeInitialFormValues(reference, ['publish'], true),
});

export const referenceEditModel = fromJS({
  name: 'referenceEditForm',
  initialValues: createInitialForm(),
});

export const formToJson = form => ({
  id: fieldToNumber(form.get('id')),
  author: fieldTrimmed(form.get('author')),
  year: fieldTrimmed(form.get('year')),
  citation: fieldTrimmed(form.get('citation')),
  ok: fieldTrimmed(form.get('ok')),
  have: fieldToNumber(form.get('have')),
  comments: fieldTrimmed(form.get('comments')),
  publish: Boolean(form.get('publish')),
});
